import { useState } from "react";
import { createPortal } from "react-dom";

import {
  getStoredConsent,
  saveConsent,
} from "../../utils/cookieConsent";
import { loadClarityScript } from "../../utils/clarity";

export default function CookieBanner({ onConsentChange }) {
  const [consent, setConsent] = useState(() => {
    const stored = getStoredConsent();
    if (stored?.analytics) loadClarityScript();
    return stored;
  });

  const [showDetails, setShowDetails] = useState(false);
  const [analyticsChecked, setAnalyticsChecked] = useState(true);

  if (consent) return null;

  function decide(analytics) {
    const saved = saveConsent({ analytics });
    if (analytics) loadClarityScript();

    setConsent(saved);
    onConsentChange?.(saved);
  }

  return createPortal(
    <div
      className="sdx"
      role="dialog"
      aria-modal="true"
      aria-label="Cookie-Einstellungen"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        display: "flex",
        justifyContent: "center",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 760,
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 12px 40px rgba(0,0,0,0.20)",
          padding: "28px 32px",
          boxSizing: "border-box",
        }}
      >
        <h2 style={{ margin: "0 0 12px 0", fontSize: 20 }}>
          Cookie-Einstellungen
        </h2>

        <p
          style={{
            margin: "0 0 20px 0",
            fontSize: "0.95rem",
            lineHeight: 1.6,
            color: "#475569",
          }}
        >
          Wir verwenden notwendige Cookies, damit diese Seite
          funktioniert, sowie optionale Analyse-Cookies
          (Microsoft Clarity), um die Nutzung zu verstehen und
          das Angebot zu verbessern. Sie können Ihre Auswahl
          jederzeit treffen.
        </p>

        {showDetails && (
          <div style={{ marginBottom: 24 }}>
            <hr
              style={{
                border: "none",
                borderTop: "1px solid #e8e8e8",
                margin: "0 0 20px 0",
              }}
            />

            <div style={{ marginBottom: 16 }}>
              <sdx-input-item
                type="checkbox"
                checked={true}
                disabled={true}
              >
                Notwendig — für den Betrieb der Seite
                erforderlich
              </sdx-input-item>
            </div>

            <div>
              <sdx-input-item
                type="checkbox"
                checked={analyticsChecked || undefined}
                onSdxChange={() =>
                  setAnalyticsChecked((prev) => !prev)
                }
              >
                Analyse — Microsoft Clarity (anonymisierte
                Nutzungsstatistik)
              </sdx-input-item>
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <sdx-button
            theme="cancel"
            variant="ghost"
            label={
              showDetails ? "Details ausblenden" : "Details"
            }
            onClick={() => setShowDetails((prev) => !prev)}
          />

          <div style={{ display: "flex", gap: 12 }}>
            {showDetails ? (
              <sdx-button
                theme="secondary"
                label="Auswahl speichern"
                onClick={() => decide(analyticsChecked)}
              />
            ) : (
              <sdx-button
                theme="secondary"
                label="Nur notwendige"
                onClick={() => decide(false)}
              />
            )}

            <sdx-button
              theme="primary"
              label="Alle akzeptieren"
              onClick={() => decide(true)}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
